import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, ButtonGroup, Fade, Paper, Typography } from "@mui/material";
import React from "react";

interface BulkActionToolbarProps {
  selectedCount: number;
  onDelete: () => void;
  onClearSelection: () => void;
  disabled?: boolean;
}

export const BulkActionToolbar: React.FC<BulkActionToolbarProps> = ({
  selectedCount,
  onDelete,
  onClearSelection,
  disabled = false,
}) => {
  if (selectedCount === 0) return null;

  return (
    <Fade in={selectedCount > 0} timeout={200}>
      <Paper
        elevation={2}
        sx={{
          position: "absolute",
          top: -50,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 100,
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          gap: 2,
          backgroundColor: "background.paper",
          border: 1,
          borderColor: "divider",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {selectedCount} trip{selectedCount > 1 ? "s" : ""} selected
        </Typography>

        <ButtonGroup variant="outlined" size="small">
          <Button
            onClick={onDelete}
            disabled={disabled}
            color="error"
            startIcon={<DeleteIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 80,
              fontSize: "0.75rem",
            }}
          >
            Delete
          </Button>
          <Button
            onClick={onClearSelection}
            disabled={disabled}
            startIcon={<ClearIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 80,
              fontSize: "0.75rem",
            }}
          >
            Clear
          </Button>
        </ButtonGroup>
      </Paper>
    </Fade>
  );
};
